const timelineData = [
  {
    text: "University of Bergamo",
    date2: "October 2023 - April 2025, University of Bergamo (this degree is useless)",
    paragraph: "Main Arguments:",
    first: "- Neural networks",
    second: "- Machine learning",
    third: "- Everything else is useless",
    category: {
      tag: "Master degree in IT engineering",
      color: "#6a5acd",
    },
  },
  {
    text: "Riga Technical University",
    date2: "January 2023 - June 2023, Riga Technical University",
    paragraph: "Main Arguments:",
    first: "- Statistical learning and optimization",
    second: "- Artificial intelligence",
    third: "- Testing and software validation",
    fourth: "- Theory of informations",
    category: {
      tag: "Erasmus study program",
      color: "#6a5acd",
    },
  },

  {
    text: "University of Bergamo",
    date2: "October 2019 - June 2022, University of Bergamo",
    paragraph: "Main Arguments:",
    first: "- Linear algebra and analysis",
    second: "- Object oriented coding",
    third: "- Data bases",
    category: {
      tag: "Bachelor degree in IT engineering",
      color: "#6a5acd",
    },
  },
];

export default timelineData;
